import React from 'react';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { Truth } from './components/Truth';
import { ProductReveal } from './components/ProductReveal';
import { Demonstration } from './components/Demonstration';
import { Benefits } from './components/Benefits';
import { Transformation } from './components/Transformation';
import { SocialValidation } from './components/SocialValidation';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen text-gray-900 antialiased selection:bg-blue-200 selection:text-blue-900 bg-[#FFFFFF]" data-id="element-0" data-mp="31agput0v2nlk">
      <header className="bg-white border-b border-gray-300 py-3 sticky top-0 z-10" data-id="element-1" data-mp="2wiyxuugtfxcq">
        <div className="max-w-4xl mx-auto px-4 flex justify-between items-center" data-id="element-2" data-mp="28tw44o8wqe1v">
          <div className="text-2xl tracking-tight text-gray-900 font-[700]" data-id="element-3" data-mp="23vkw8j26adma">
            Daily Living Finds
          </div>
          <div className="text-[10px] sm:text-xs font-bold text-gray-400 uppercase tracking-widest" data-id="element-4" data-mp="3ikqz80j1f669">
            Advertisement
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 sm:px-10 py-10 shadow-sm min-h-screen bg-[#F6F4F0]" data-id="element-5" data-mp="3rc9co3oln7vn">
        <Hero data-id="element-6" data-mp="5yh2n2cyzbp" />
        <Story data-id="element-7" data-mp="6hovayao7c0" />
        <Truth data-id="element-8" data-mp="4wupmfw6qeo" />
        <ProductReveal data-id="element-9" data-mp="5gel8p3rovc" />
        <Demonstration data-id="element-10" data-mp="82j0zgp5o9c" />
        <Benefits data-id="element-11" data-mp="2zld0746gb58w" />
        <Transformation data-id="element-12" data-mp="2zlv84y2h77wn" />
        <SocialValidation data-id="element-13" data-mp="2zmo557bmuj1l" />
        <FAQ data-id="element-14" data-mp="2zng1ikd20ksx" />
        <FinalCTA data-id="element-15" data-mp="33mowttnqsqql" />
      </main>
      <Footer data-id="element-16" data-mp="33lx18iu5at0b" />
    </div>;
}